import path from 'path';

/**
 * Get from monorepo root
 */
export function getFromRoot(to: string): string {
  return path.resolve(__dirname, `../../../../${to}`);
}
